import {h} from 'preact';
import url from 'url';

export const IMAGE_RESIZE_SVC_PATH = `${upi.paths.IMAGES_ORIGIN_CDN}/ImageResizer.svc/GetResizedImage`;
export const SKU_RESIZE_SVC_PATH = `${upi.paths.IMAGES_ORIGIN_CDN}/ImageResizer.svc/GetResizedSkuImage`;

export function getImageSvcUri ( type, path, size = 120, quality = 70 ) {
    const pixelRatio = window.devicePixelRatio || 1;
    let imgQuery = {
        quality,
        size: `w|${ size * pixelRatio }`
    };

    // toggle param and service endpoints for SKU images
    imgQuery[(type === 'sku') ? 'sku' : 'path'] = path;

    return url.format( {
        ...url.parse( type === 'sku' ? SKU_RESIZE_SVC_PATH : IMAGE_RESIZE_SVC_PATH ),
        query: imgQuery
    } );
}

const SizedImage = props => {

    const
        {type, src, width, size, alt, className} = props,
        imgUri = getImageSvcUri( type, src, width || size );

    return <img className={className} {...props} alt={alt} src={imgUri}/>
};

/*SizedImage.propTypes = {
 type: PropTypes.oneOf( [ 'image', 'sku' ] ).isRequired,
 style: PropTypes.object,
 alt: PropTypes.string,
 src: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
 };*/

SizedImage.defaultProps = {
    alt: '',
    type: 'image',
    size: 360
};

export default SizedImage;
